import React from "react";
import Company from "../Components/Common/HeadTitle";
import Tabs from "../Components/Product/JSTabs";

// 제품소개 화면배치
function Product() {
  return (
    <div>
      <Company />
      <Tabs />
    </div>
  );
}

export default Product;
